import { useTranslations } from "use-intl";
import { cn } from "@/lib/utils";

export function DayPicker({
  value,
  onChange,
  disabledDays = [],
}: {
  value: number[];
  onChange: (days: number[]) => void;
  disabledDays?: number[];
}) {
  const t = useTranslations("weekdays.short");
  return (
    <div className="grid grid-cols-7 gap-1.5">
      {Array.from({ length: 7 }, (_, i) => {
        const on = value.includes(i);
        const disabled = disabledDays.includes(i);
        return (
          <button
            key={i}
            type="button"
            disabled={disabled}
            aria-pressed={on}
            onClick={() => onChange(on ? value.filter((d) => d !== i) : [...value, i].sort())}
            className={cn(
              "h-11 rounded-xl border text-sm font-semibold transition-colors disabled:opacity-30",
              on ? "border-primary bg-primary text-primary-foreground" : "bg-background",
            )}
          >
            {t(String(i) as "0")}
          </button>
        );
      })}
    </div>
  );
}
